module.exports = __webpack_public_path__ + "static/media/qasir_sign_in.486c223a.JPG";